/**
 * Created by evgeny on 17.06.2024
 */

if (typeof cc === "undefined") {
    module.exports = Families;
}